<template>
  <div class="p-menu-plan-block sm_container">
    <!-- 給トク表示: PC表示 -->
    <p class="label-available-salary" v-if="checkAvailableSalary && innerWidth > 744">給トク払いが使えるプランです！</p>
    <div
      class="p-menu-plan-block__outside pointer-cusor sm_wrapper"
      :class="{
        'p-menu-plan-block--recommend': recommend
      }"
      v-for="itemPlan,index in limitPlans"
      :key="index"
      @click="openLink(itemPlan.planBasicInfo.planId)"
    >
      <div v-if="itemPlan.planBasicInfo" class="p-menu-plan-block__inner">
        <!-- 給トク表示: SP表示 -->
        <p class="sm_aeSalary" v-if="checkAvailableSalary && innerWidth <= 744">給トク払いが使えるプランです！</p>

        <!-- プラン画像 -->
        <div class="p-menu-plan-block__image" v-if="getPlanImage(index)">
          <img :src="getPlanImage(index)" />
        </div>

        <!-- プラン詳細情報 -->
        <div
          class="p-menu-plan-block__contents"
          :class="{
            'p-menu-plan-block__contents--wide': !itemPlan.planBasicInfo.planImages
          }"
        >
          <!-- プランタイトル -->
          <p class="p-menu-plan-block__title sm_title">
            {{ itemPlan.planBasicInfo.planNm }}
          </p>

          <!-- TODO:plan.planTypeは消去する -->
          <!-- plan グルメは対象外の為非表示とする -->
          <!-- <ul
            v-if="plan.planType === 3"
            class="p-menu-plan-block__status p-menu-plan-block__status--gourmet"
          >
            <li v-for="item in plan.gourmetStatus" :key="item.id">
              <Icon :name="iconType(item.type)" />{{ item.label }}
            </li>
          </ul> -->
          <!-- プランのディスカウント表記 -->
          <template  v-if="innerWidth <= 744">
          <p class="sm_discount" :key="index" v-for="(plan,index) in itemPlan.benefitHeadlines">
            {{ plan.benefitHeading }}
            <span>{{ plan.benefitContent }}</span>
          </p>
          </template>

          <TagIconItems
            :menu="menu"
            :plan="itemPlan"
          />

          <!-- お申し込み期間と詳細を見るボタン -->
          <!-- contents配下はプラン種別によって変更になる？（それぞれ別コンポーネントにする想定） -->
          <template>
            <MenusPlanLife :menuNo="menuNo" :plan="itemPlan" :usageDiv="usageDiv"/>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import MenusPlanLife from '../MenusPlanLife'
import TagIconItems from '../TagIconItems'
export default {
  props: {
    menuNo: {
      required: true
    },
    recommend: {
      default: 0
    },
    menu: {
      type: Object,
    },
    plan: {
      type: [Object, Array],
    },
    planDetails: {
      type: [Object , Array],
    },
    usageDiv: {
      default: 0
    },
  },
  components: {
      MenusPlanLife, TagIconItems
  },
  data() {
    return {
      innerWidth: window.innerWidth
    };
  },
  computed: {
    limitPlans(){
      if (this.$route.path.indexOf("plans") >= 0) {
        return [this.plan]
      }
      if(this.plan.length > 3) return this.plan.slice(0,3)
      return this.plan
    },
    limitPlanDetails(){
      if (this.$route.path.indexOf("plans") >= 0) {
        return [this.planDetails]
      }
      if(this.planDetails.length > 3) return this.planDetails.slice(0,3)
      return this.planDetails
    },
    checkAvailableSalary() {
      let hasAvailableSalary = false
      if (this.plan.menuIcons) {
        this.plan.menuIcons.every(icon => {
          if (['pyrl_ded_tsudo','pyrl_ded_keizoku'].includes(icon.iconCd)) {
            hasAvailableSalary = true
            return false
          } else {
            return true
          }
        });
      }
      return hasAvailableSalary
    },
    queryCode() {
      return {
        category: this.$route.params.category
          ? this.$route.params.category.replace("category=", "")
          : "",
        rooms: this.$route.params.rooms
          ? this.$route.params.rooms.replace("rooms=", 1)
          : "",
        roomCnt: this.$route.params.roomCnt
          ? this.$route.params.roomCnt.replace("roomCnt=", 1)
          : "",
        numPeople: this.$route.params.numPeople
          ? this.$route.params.numPeople.replace("numPeople=", 2)
          : "",
        menuNo: this.$route.params.menuNo
          ? this.$route.params.menuNo.replace("menuNo=", "")
          : "",
        stayNights: this.$route.params.stayNights
          ? this.$route.params.stayNights.replace("stayNights=", 1)
          : "",
        adultHeadCnt: this.$route.params.adultHeadCnt
          ? this.$route.params.adultHeadCnt.replace("adultHeadCnt=", 2)
          : "",
        feeUpper: this.$route.params.feeUpper
          ? this.$route.params.feeUpper.replace("feeUpper=", 20000)
          : ""
      };
    },
  },
  methods: {
    checkBenepoReturnInfo(index){
       return this.limitPlanDetails?.[index]?.benepoReturnInfo?.benepoReturnDiv
    },
    iconType(type) {
      let iconName = "status_";
      switch (type) {
        case 1:
          iconName += "morning";
          break;
        case 2:
          iconName += "lunch";
          break;
        case 3:
          iconName += "teatime";
          break;
        case 4:
          iconName += "dinner";
          break;
      }
      return iconName;
    },
    // 取得したイメージオブジェクトが配列かどうかチェック
    isPlanImagesArray(index) {
      const objectType = Object.prototype.toString;
      return (
        objectType.call(this.limitPlans[index].planBasicInfo.planImages) == "[object Array]"
      );
    },
    // 取得したイメージを返す
    getPlanImage(index) {
      if (this.isPlanImagesArray(index)) {
        if (this.limitPlans[index].planBasicInfo.planImages.length == 0) return "";
        return this.limitPlans[index].planBasicInfo.planImages[0].imageUrl;
      } else {
        return this.limitPlans[index].planBasicInfo.planImages;
      }
    },
    openLink(planId){
      const {menuNo} = this.queryCode
      const href = `${process.env.VUE_APP_BASE_URL}/dp/menus/${menuNo}/plans/${planId}`
      location.href = href
    },
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import './style.scss';
.label-available-salary {
  margin: 0;
  background: deepskyblue;
  padding: 10px 20px;
  border: 1px solid deepskyblue;
  color: white;
  font-weight: 700;
}

.label-available-salary ~ .p-menu-plan-block__outside {
  &.p-menu-plan-block--recommend {
    margin-top: 0;
    border: 1px solid deepskyblue;
  }
}

.c-lists__list__label {
    min-width: 120px;
    font-size: .875rem;
    text-align: center;
    padding: 4px;
    margin-right: 1.5rem;
    background-color: #FDF1F1;
    margin-top: 0;
    margin-bottom: 0;
}

@include mq() {
  .c-lists__list__label {
    width: 80px;
  }
}
.pointer-cusor {
  cursor: pointer;
}

@media screen and (max-width: $contentWidthS) {
  .sm {
    &_container {
      border-radius: 6px;
      box-shadow: 0 0 6px #00000029;
    }
    &_wrapper {
      padding: 20px 12px;
    }
    &_aeSalary {
      display: block;
      margin: 0 -12px 16px;
      padding: 9px 0;
      font-size: 13px;
      line-height: 19.5px;
      text-align: center;
      background-color: #259BEE;
      color: white;
      font-weight: bold;
    }
    &_title {
      font-size: 16px;
      margin-bottom: 12px;
      color: #1f2021;
    }
    &_discount {
      font-size: 12px;
      margin-bottom: 4px;
      color: #1f2021;
      span {
        color: #DD0000;
        font-weight: bold;
      }
    }
    &_tag {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      &_benepo {
        margin-right: 8px;
        padding: 2px 8px;
        font-size: 10px;
        line-height: 15px;
        color: #1f2021;
        background-color: #FDF1F1;
      }
      &_other {
        &_list {
          display: flex;
          align-items: center;
        }
        &_item {
          display: block;
          margin-right: 8px;
          padding: 2px 8px;
          font-size: 10px;
          line-height: 15px;
          color: #1f2021;
          background-color: #FDF1F1;
        }
      }
    }
    &_planIcon {
      margin-bottom: 0;
    }
  }
}
</style>
